module.exports = __webpack_public_path__ + "static/img/tabela.8e0f24c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/laranja/tabela.png
// module id = g/JT
// module chunks = 0